
document.getElementById("mobile-button").addEventListener("click", handleMobileMenu);
document.querySelector(".search-input-mobile").addEventListener('focus', handleFocus);
document.querySelector(".search-input-mobile").addEventListener('blur', handleBlur);
document.querySelector(".nav-mobile-menu").addEventListener("click", handleMobileClose);
document.querySelector(".nav-mobile-menu__icon-search").addEventListener("click", toggleSearchbar);

const parentMobileMenu = document.querySelector(".nav-mobile-menu__parent-menu");
const shopSubmenu = document.querySelector(".shop-submenu");
const whyNordicSubmenu = document.querySelector(".why-nordic-submenu");
const learnSubmenu = document.querySelector(".learn-submenu");

document.querySelectorAll(".nav-mobile-menu__parent-menu-item").forEach(button =>
    button.addEventListener("click", (e) => {
        parentMobileMenu.classList.add("sub-nav-opened");
        if (e.target.textContent.trim() === "Shop") {
            shopSubmenu.classList.add("opened");
        }
        if (e.target.textContent.trim() === "Why Nordic") {
            whyNordicSubmenu.classList.add("opened");
        }
        if (e.target.textContent.trim() === "Learn") {
            learnSubmenu.classList.add("opened");
        }
    })
);

document.querySelectorAll(".close-sub-menu").forEach(button =>
    button.addEventListener("click", (e) => {
        console.log(e);
        parentMobileMenu.classList.remove("sub-nav-opened");
        e.target.parentNode.classList.remove("opened");
    })
);

function handleMobileMenu (e) {
    document.querySelector(".nav-mobile-menu").classList.remove("mobilenav-closed");
    document.querySelector("body").classList.add("modal-open");
}

function handleSearch (e) {
    const container = document.querySelector(".site-header__search");
    container.classList.toggle('active');

}

function handleFocus (e) {
    const container = document.querySelector(".nav-mobile-menu__search");
    container.classList.add('has-text');
}

function handleBlur (e) {
    const container = document.querySelector(".nav-mobile-menu__search");
    if (e.target.value.length > 0) {
        container.classList.add('has-text');
    } else {
        container.classList.remove('has-text');
    }
}

function handleMobileSubMenu (e) {
    console.log('MOBILE SUB MENU CLICKED');
}

function handleMobileClose (e) {
    if (e.target.classList[0] === "nav-mobile-menu") {
        document.querySelector(".nav-mobile-menu").classList.add("mobilenav-closed");
        document.querySelector("body").classList.remove("modal-open");
    }
}

function toggleSearchbar (e) {
    const container = document.querySelector('.nav-mobile-menu__search');
    container.classList.toggle('active');
    container.classList.toggle('has-text');
}
